import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // Start at 13 minutes 25 seconds as per copy
  const [timeLeft, setTimeLeft] = useState(13 * 60 + 25);
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 0) {
          // Reset to 15 minutes when it hits zero to maintain urgency
          return 15 * 60;
        }
        return prevTime - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="w-full bg-red-50 border-2 border-red-100 rounded-lg p-3 md:p-4 my-3 md:my-6 text-center animate-pulse-slow content-section" data-id="element-89">
      <div className="flex items-center justify-center gap-2 mb-2 md:mb-3" data-id="element-90">
        <Clock className="w-5 h-5 text-red-600" data-id="element-91" />
        <h3 className="text-red-700 font-bold uppercase tracking-wider text-sm md:text-base" data-id="element-92">
          OFERTA SOLO POR HOY !!!
        </h3>
      </div>

      <p className="text-gray-700 text-sm mb-2 md:mb-3" data-id="element-93">
        Reserva válida por 15 minutos. Si no accedés, tu descuento pasa a la
        siguiente persona.
      </p>

      <div className="flex items-center justify-center gap-1 text-2xl md:text-4xl font-heading font-bold text-red-600" data-id="element-94">
        <div className="bg-white px-2 py-1 rounded shadow-sm border border-red-100 min-w-[50px] md:px-3 md:min-w-[60px] tabular-nums" data-id="element-95">
          {minutes.toString().padStart(2, '0')}
        </div>
        <span className="pb-2" data-id="element-96">:</span>
        <div className="bg-white px-2 py-1 rounded shadow-sm border border-red-100 min-w-[50px] md:px-3 md:min-w-[60px] tabular-nums" data-id="element-97">
          {seconds.toString().padStart(2, '0')}
        </div>
      </div>
    </div>;
}